import { useRequest, useParams, Helmet } from 'umi';
import React, { useState } from 'react';
import styles from '../css/dynamicCSS.less';
import cx from 'classnames';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import { MessageOutlined } from '@ant-design/icons';
import DynamicPraise from './dynamicPraise';
import { ReactComponent as RewardSvg } from '@/static/images/reward2.svg';
import { calcTimeString } from '@/utils';
import selectedPng from '@/static/images/selected.png';
import Editor from '@digit-fe/digit-editor-new';
import { editParseJson } from '@/utils/index';

interface Props {
  item: DynamicType;
}
const DynamicDetailsItem: React.FC<Props> = ({ item }) => {
  return (
    <>
      <div className={styles.dynamic_box}>
        <div className={styles.item}>
          <div className={styles.lf}>
            <a href={`https://bbs.fanruan.com/u/${item.createdBy}`} target="_blank">
              <img
                className={styles.face}
                src={`https://bbs.fanruan.com/uc_server/avatar.php?uid=${item.createdBy}&amp;size=small`}
              ></img>
            </a>
          </div>
          <div className={styles.rt}>
            <div className={styles.user_name}>
              <a
                href={`https://bbs.fanruan.com/u/${item.createdBy}`}
                className="col172 hover008 f16"
                target="_blank"
              >
                {item.username}
              </a>
            </div>
            <div className={cx(styles.info, 'col808 f14')}>
              <span>{calcTimeString(item.createdTime)}</span>
            </div>
            <div className={styles.info_text}>
              <Editor
                content={editParseJson(item.content)}
                editable={false}
                titleProps={{ showTitle: false }}
                catalogProps={{ showCatalog: false }}
              />
            </div>

            <div>
              <span className={styles.node_name}>{item.nodeName}</span>
            </div>

            <div className={cx(styles.tool, 'flex_1')}>
              <div className="f14">
                <DynamicPraise data={item} type={1} />
              </div>
              <div className={cx(styles.comment, 'flex_1 col808')}>
                <MessageOutlined />
                <span>评论 {item.commentsCount > 0 ? item.commentsCount : ''}</span>
              </div>

              {item.rewardCredits > 0 && (
                <div className={cx(styles.reward, 'flex_1')}>
                  <RewardSvg style={{ width: 15 }} />
                  <span className="colffa">奖励 {item.rewardCredits} 学分</span>
                </div>
              )}
            </div>
          </div>
          {item.selected == 1 && (
            <div className={styles.selected}>
              <img src={selectedPng} style={{ width: 80, height: 80 }} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default DynamicDetailsItem;
